import { Outlet } from 'react-router-dom';
import { Header } from '../components/header';
import { Footer } from '../components/footer';
import { PreviewPublishProvider } from '../features/preview/PreviewPublishContext';

import styles from './Layout.module.css';

export function Layout() {
    return (
        <PreviewPublishProvider>
            <div className={styles.layout}>
                <Header />
                <main>
                    <Outlet />
                </main>
                <Footer />
            </div>
        </PreviewPublishProvider>
    );
}
